import { useIntl } from "react-intl";

import Alert from "components/v2/Alert/Alert";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import DeliveryServiceLevelFields from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection/DeliveryServiceLevelFields";
import StopAvailableHours from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection/StopAvailableHours";
import StopDateTimeFields from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection/StopDateTimeFields";
import StopInstructions from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection/StopInstructions";
import StopTimeTypeField from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection/StopTimeTypeField";
import { useDeliveryServiceLevel } from "@RequestFormV2/sections/Schedule/hooks/useDeliveryServiceLevel";
import { StopPlanningSlice } from "@RequestFormV2/sections/Schedule/hooks/useStopPlanning";

interface ScheduleSectionProps {
  planning: StopPlanningSlice;
  stopIndex: number;
}

export default function ScheduleSection({ planning, stopIndex }: ScheduleSectionProps) {
  const intl = useIntl();
  const deliveryServiceLevel = useDeliveryServiceLevel(stopIndex);
  const { showDeliveryDatetimeFields, showPickupDateRequiredMessage, isDeliveryDatetimeLocked } =
    deliveryServiceLevel;

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.schedule.planning.label",
          defaultMessage: "Schedule",
        })}
        required
      />

      <div className="rfv2-form-section__content rfv2-schedule-planning">
        <DeliveryServiceLevelFields deliveryServiceLevel={deliveryServiceLevel} />
        {showPickupDateRequiredMessage && (
          <div className="rfv2-schedule-service-level">
            <Alert variant="gray" label="">
              {intl.formatMessage({
                id: "new-request.timing.pickupDateNotSelected",
                defaultMessage: "Pickup date not selected",
              })}
            </Alert>
          </div>
        )}
        {showDeliveryDatetimeFields && (
          <StopTimeTypeField
            planning={planning}
            stopIndex={stopIndex}
            lockTimeType={isDeliveryDatetimeLocked}
          />
        )}
        {showDeliveryDatetimeFields && (
          <StopDateTimeFields
            planning={planning}
            stopIndex={stopIndex}
            lockDateFields={isDeliveryDatetimeLocked}
          />
        )}
        <StopAvailableHours planning={planning} stopIndex={stopIndex} />
        <StopInstructions planning={planning} stopIndex={stopIndex} />
      </div>
    </div>
  );
}
